import './ui-elements'
import './animations'
import './form'
import './popup'
import './headercatalog'
import './header-search'
import './cart'
import './mediator'
import './product'
import './header'
import './catalog-top-filter'
import './filter'
import {isMobile} from "./utils";


const MxShop = {};

MxShop.initCallBack = function () {
    /*MxShop.initDatalayer();
    $.Filter.init();
    MxShop.initHeaderSocialButtons();
    MxShop.initSuggestCityPopup();
     */
}

MxShop.initSuggestCityPopup = function () {
    let isShowing = MxShop.ReadCookie("ShowPopupCity");
    if (isShowing) {
        $(".js-modal-city").removeClass("hidden");
        MxShop.RemoveCookie("ShowPopupCity");
    }
}
MxShop.WriteCookie = function (name, value, days, domain = "") {
    let expires;
    let suffixCookie = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    if (domain !== "") {
        suffixCookie = location.hostname !== "localhost" ? "; domain=" + domain : "";
    }
    document.cookie = name + "=" + value + expires + "; path=/" + suffixCookie;
}
MxShop.ReadCookie = function (cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
MxShop.RemoveCookie = function (name, path, domain) {
    path = path ? path : "/";
    domain = location.hostname !== "localhost" ? ".mx-zapchasti.ru" : domain;
    console.log('cookies', path, domain);
    document.cookie = name + "=" +
        ((path) ? ";path=" + path : "") +
        ((domain) ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}
MxShop.ToggleTag = function (tagName) {
    let tags = $('.js-consumable-slider .tags__list .tags__item');
    tags.each(function () {
        let tag = $(this);
        if (tag.text() === tagName) {
            tag.toggleClass('tag--active');
        }
    });
    $(tags[0]).removeClass('tag--active');
}
MxShop.ExpandProducts = function () {
    $('.product-modifications__showall').click();
}
MxShop.ClearTags = function () {
    let tags = $('.js-consumable-slider .tags__list .tags__item');
    tags.removeClass('tag--active');
    $(tags[0]).addClass('tag--active');
}
MxShop.GetCallbackMessageFromPage = function () {
    return $('.js-input-questions').val();
}
MxShop.showPopup = function (target) {
    openPopup(target, undefined, undefined);
}
MxShop.getCheckoutForm = function () {
    let $form = $('.order-checkout__form').find('form');
    let data = $form.serializeArray();
    return JSON.stringify(data);
}
MxShop.getFile = function (containerClass, resultClass = null, callback = null) {
    $('.order-checkout__form').find('button[type="submit"]').attr("disabled", true);
    let container = $(containerClass)[0];
    let result = readUploadedFileAsText(container);
    if (resultClass !== null) {
        result.then(data => {
            $(resultClass).val(data);
            if (callback !== null) {
                callback();
            }
        })
    } else {
        return result;
    }
}
MxShop.GetValue = function (containerClass) {
    return $(containerClass).val();
}
MxShop.GetText = function (containerClass) {
    return $(containerClass).text();
}
MxShop.afterCheckoutFileUploaded = function () {
    let formWrapper = $('.order-checkout__form');
    formWrapper.find('button[type="submit"]').removeAttr("disabled");
    formWrapper.find('input[name="inn"]').removeAttr('required');
}
MxShop.initCartCheckout = function () {
    let block = $('div.order-checkout');
    block.block({message: null});
    initUploadFile();
    formValidate();
    block.unblock();
}
MxShop.initOrderDelivery = function () {
    //window.initTabBar();
    window.initSelect();
    window.initDeliveryPopup();
    $B.on('change', '.js-order-delivery input[type=radio]', function () {
        $('.order-checkout__form').find('input[name="address"]').val('');
        $('.js-order-delivery').removeClass('is-active');
        $(this).parents('.js-order-delivery').addClass('is-active');
    });
}
MxShop.initHeaderCityPicker = function () {
    $('.js-select-citypicker')
        .select2({
            dropdownAutoWidth: false,
            containerCssClass: 'select',
        }).on('select2:select', function (e) {
        let value = $('.js-select-citypicker').val() || "1|Москва|1";
        let [id, cityId, groupId] = value.split("|");
        let cityBass64 = window.btoa(unescape(encodeURIComponent(cityId)));
        MxShop.WriteCookie("CurrentCity", cityBass64, 365, ".mx-zapchasti.ru");
        MxShop.WriteCookie("CurrentDomain", id, 365, ".mx-zapchasti.ru");
        MxShop.WriteCookie("CurrentGroup", groupId, 365, ".mx-zapchasti.ru");
        location.reload();
    });

    $(".citypicker-popup__item").on("click", function () {
        let $item = $(this);
        MxShop.WriteCookie("CurrentCity", $item.data("city"), 365, ".mx-zapchasti.ru");
        MxShop.WriteCookie("CurrentDomain", $item.data("id"), 365, ".mx-zapchasti.ru");
        MxShop.WriteCookie("CurrentGroup", $item.data("group"), 365, ".mx-zapchasti.ru");
        location.reload();
    });
}
MxShop.onSoftFilterChange = function () {
    initSelect();
    $('select').on('select2:select', function (e) {
        let filter = {};
        $('.js-select').each(function (i, $select) {
            let select = $($select);
            filter[select.attr('name')] = select.val();
        });
        let url = new URL(window.location.href);
        for (let key in filter) {
            url.searchParams.set(key, filter[key]);
        }
        window.location.href = url;
    });
}
MxShop.setSelect2Value = function (selector, val) {
    $(selector).val(val);
    $(selector).trigger('change');
}
MxShop.IsMobile = function () {
    return isMobile();
}
window.shop = MxShop;
$(function () {
    MxShop.initCallBack();
});

